import { UserAuthToken } from '@sonar-software/sonar-security';
import { createGetEndpoint, HttpHeader } from '@sonar-software/sonar-http';

export type GetImpersonatedUserTokenRequest = {
	userId: number;
	shardName?: string;
};

export type GetImpersonatedUserTokenResponse = UserAuthToken;

export const getImpersonatedUserToken = createGetEndpoint<
	GetImpersonatedUserTokenRequest,
	GetImpersonatedUserTokenResponse
>((request) => `/api/v3/security/authentication/impersonate/${request?.userId}`, {
	headers: (request) => {
		if (request?.shardName) {
			return { [ HttpHeader.Shard ]: request.shardName };
		}

		return {};
	},
	skipAuthRefresh: true
});
